var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.638,
    height: 26.742,
    viewBox: "0 0 44.638 26.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vnjgsxo0xa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    d: "M0 0h42v16a9 9 0 0 1-9 9H1a1 1 0 0 1-1-1V0z",
    transform: "translate(-741 -797.258) translate(741 799)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vnjgsxo0xa)",
    transform: "translate(-741 -797.258) matrix(1, 0, 0, 1, 741, 797.26)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v16a9 9 0 0 1-9 9H1a1 1 0 0 1-1-1V0z",
    transform: "translate(0 1.74)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f4",
    d: "M9395.338 2083.067h-42.013l2.041-1.742h42.6z",
    transform: "translate(-741 -797.258) translate(-8612.325 -1284.067)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandle);
export default __webpack_public_path__ + "static/media/handle.a52c20b6f94e0654563ef6125bb6dc42.svg";
export { ForwardRef as ReactComponent };